import * as React from 'react'
import { useTranslations } from 'next-intl'

import { postV1UsersClient } from '@/generated/clients/axios/UsersService'
import { parseResponseErrors } from 'utils/api-errors'
import { REGION_ID_BY_COUNTRY_CODE } from 'utils/api-constants'
import { mapUserToUserType } from 'utils/api-type-mappers'
import * as store from 'utils/store'
import AuthContext from 'lib/authContext'
import { useCountry } from 'lib/withCountry'

import AuthHeader from 'components/AuthHeader'
import RegistrationForm from 'components/RegistrationForm'
import MobileRegistrationForm from 'components/MobileRegistrationForm'

import { Mobile } from 'utils/responsive'

function RegistrationPage() {
  const t = useTranslations()
  const { country } = useCountry()
  const authContext = React.useContext(AuthContext)

  async function handleSubmit(values: any, actions: any) {
    actions.setSubmitting(true)

    const utmSource = await store.get('utmSource')

    // Assign regionId numeral value to the User based on Country
    const regionId = REGION_ID_BY_COUNTRY_CODE[country]

    try {
      const { data } = await postV1UsersClient({
        user: {
          email: values.email,
          password: values.password,
          password_confirmation: values.passwordConfirmation,
          first_name: values.firstName,
          last_name: values.lastName,
          phone: values.phone,
          region_id: regionId,
          ...(typeof utmSource === 'string' && { utm_source: utmSource }),
        },
      })
      const userData = mapUserToUserType(data)
      authContext.login(data.jwt_token!, userData)

      if (typeof utmSource === 'string') {
        await store.clear('utmSource')
      }
    } catch (error: any) {
      actions.setSubmitting(false)
      console.log('Error submitting registration', error)

      const submitErrors = parseResponseErrors(error, t)
      if (submitErrors && Object.keys(submitErrors).length > 0) {
        actions.setErrors(submitErrors)
      }
    }
  }

  return (
    <div className="container">
      <AuthHeader registration />

      <Mobile>
        {(isMobile: boolean) =>
          isMobile ? (
            <MobileRegistrationForm onSubmit={handleSubmit} />
          ) : (
            <RegistrationForm onSubmit={handleSubmit} />
          )
        }
      </Mobile>
    </div>
  )
}

RegistrationPage.title = 'registrationPage.title'

export default RegistrationPage
